import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/compat';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import DealerDistinction from './DealerDistinction';
import RecognizedIcon from 'dibs-vg/dist/react/recognized-ribbon';
import TopSellerIcon from 'dibs-vg/dist/react/diamond';
import VettedIcon from 'dibs-vg/dist/react/vetted-checkmark';

const recognizedTitle = (
    <FormattedMessage id="pdp.DealerDistinctions.recognizedTitle" defaultMessage="Recognized" />
);
const recognizedDescription = (
    <FormattedMessage
        id="pdp.DealerDistinctions.recognizedDescription"
        defaultMessage="This designation is for sellers whose items consistently exemplify the best of 1stdibs."
    />
);
const topSellerTitle = (
    <FormattedMessage id="pdp.DealerDistinctions.topSellerTitle" defaultMessage="Top Seller" />
);
const topSellerDescription = (
    <FormattedMessage
        id="pdp.DealerDistinctions.topSellerDescription"
        defaultMessage="This distinction represents the top 25% of sellers, based on sales."
    />
);
const vettedTitle = (
    <FormattedMessage id="pdp.DealerDistinctions.vettedTitle" defaultMessage="Vetted" />
);
const vettedDescription = (
    <FormattedMessage
        id="pdp.DealerDistinctions.vettedDescription"
        defaultMessage="This mark indicates this seller was approved by our experienced team of specialists."
    />
);

function DealerDistinctions({ seller }) {
    const isRecognized = get(seller, 'isDistinguished');
    const isTopSeller = get(seller, 'isTopSeller');

    return (
        <div className="pdp-dealer-distinctions">
            {isRecognized && (
                <DealerDistinction
                    icon={RecognizedIcon}
                    title={recognizedTitle}
                    description={recognizedDescription}
                />
            )}
            {isTopSeller && (
                <DealerDistinction
                    icon={TopSellerIcon}
                    title={topSellerTitle}
                    description={topSellerDescription}
                />
            )}
            <DealerDistinction
                icon={VettedIcon}
                title={vettedTitle}
                description={vettedDescription}
            />
        </div>
    );
}

DealerDistinctions.propTypes = {
    seller: PropTypes.object.isRequired,
};

export default createFragmentContainer(DealerDistinctions, {
    seller: graphql`
        fragment DealerDistinctions_seller on Seller {
            isTopSeller
            isDistinguished
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/DealerDistinctions/DealerDistinctions.jsx